interface FilterRowProps {
  label: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  onSelectAll: () => void;
}

export default function FilterRow({ label, options, selected, onToggle, onSelectAll }: FilterRowProps) {
  const isAll = selected.length === 0;

  return (
    <div className="flex flex-col gap-2 border-b border-background-200 py-4 last:border-b-0 sm:flex-row sm:gap-4">
      <div className="flex w-full shrink-0 items-center gap-2 sm:w-24">
        <span className="text-xs font-medium text-foreground-500">{label}</span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={onSelectAll}
          className={`rounded-md px-3 py-1.5 text-xs whitespace-nowrap transition-colors cursor-pointer ${
            isAll
              ? "bg-primary-800 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-background-200"
          }`}
        >
          全部
        </button>
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              onClick={() => onToggle(option)}
              aria-pressed={active}
              className={`flex items-center gap-1 rounded-md px-3 py-1.5 text-xs whitespace-nowrap transition-colors cursor-pointer ${
                active
                  ? "bg-secondary-500 text-primary-950 font-medium"
                  : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
              }`}
            >
              {active && <i className="ri-check-line text-[11px]" aria-hidden="true"></i>}
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}